import {
  ToggleGroup,
  ToggleGroupItem,
} from "@tokenterminal/ui/ToggleGroup/ToggleGroup"
import type { ZoomOption, ZoomValues } from "./constants"

interface Props {
  onChange: (value: ZoomValues) => void
  selectedValue?: ZoomValues
  items: Array<ZoomOption>
  disabled?: boolean
}

export function Selector({
  onChange,
  selectedValue,
  items,
  disabled: isDisabled,
}: Props) {
  return (
    <ToggleGroup>
      {items.map(({ label, value, tooltip, disabled }, index) => (
        <ToggleGroupItem
          key={index}
          isActive={selectedValue === value}
          onClick={() => {
            onChange(value)
          }}
          data-tooltip={tooltip}
          disabled={!!disabled || isDisabled}
        >
          {label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
